<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    class="wt-title-advanced"
    v-html="cleanMessage()"
  />
  <!--eslint-enable-->
</template>

<script>
export default {
  name: 'WelcomeTitleAdvanced',
  props: {
    titleText: {
      type: String,
      default: '',
    },
  },
  methods: {
    cleanMessage() {
      return this.$sanitize(this.titleText);
    },
  },
};
</script>

<style lang="postcss">
.wt-title-advanced {
  /* @apply flex justify-center text-black font-light text-4xl; */
  @apply flex justify-center text-center text-black font-semibold text-4xl;

  /* > span {
    @apply block ml-2 font-black;
  } */
}
</style>
